import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { AssignedClientsApiService } from 'features/assigned-clients/api/assign-clients-api.service';
import { queryClient } from 'providers';

import { AssignClientsQueryKeys } from './query-keys';
const { MarkAsResolved } = AssignedClientsApiService();

export const useCreateResolved = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: FormData) => {
      return MarkAsResolved(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: AssignClientsQueryKeys.all,
        });
      },
    },
  );
};
